import React, { useState } from 'react';
import Select from 'react-select';
import { Label, ErrorText } from '../lib';

const SelectInput = React.forwardRef((props, ref) => {
    const { name, label, options, defaultValue, error, onChange, ...rest } = props;
    const [valueSelect, setValueSelect] = useState(defaultValue);

    const customStyles = {
        menu: (provided, state) => ({
            ...provided, backgroundColor: state.selectProps.bg
        }),
        control: (provided, state) => ({
            ...provided, minHeight: '35px', border: 'none', backgroundColor: state.selectProps.bg
        }),
        singleValue: (provided, state) => ({
            ...provided, backgroundColor: state.selectProps.bg
        })
    };

    const handleSelectChange = (e) => {
        const newValue = {label: e.value, value: e.value};
        setValueSelect(newValue);
        if (onChange) {
            onChange({ target: { name, value: e.value } });
        }
    };

    return (
        <div style={{ marginBottom: '10px', width: '100%' }}>
            <Label htmlFor={name}>{label}</Label>
            <Select 
                name={name}
                ref={ref}
                value={valueSelect} 
                onChange={handleSelectChange} 
                styles={customStyles} 
                bg={'#f1f2f7'} 
                options={options} 
                placeholder={'Seleccionar'} 
                {...rest}
            />
            {error && <ErrorText>{error}</ErrorText>}
        </div>
    )
});

// SelectInput.defaultProps = {
//     options: [],
//     className: ""
// }

// SelectInput.propTypes = {
//     name: PropTypes.string.isRequired,
//     options: PropTypes.array.isRequired,
//     placeholder: PropTypes.string,
//     className: PropTypes.string,
//     value: PropTypes.any,
//     onChange: PropTypes.func.isRequired
// }

export default React.memo(SelectInput);